import { useState } from "react";
import { CaretDown } from "@phosphor-icons/react";

const FAQS = [
  {
    q: "Is TrueStream free?",
    a: "Yes. Anonymous browsers get three free fact-checks per session. Sign in with Google (also free) to keep checking without any cap — we only capture your email so we can raise your quota.",
  },
  {
    q: "Where do the verdicts come from?",
    a: "Every claim is cross-referenced against IFCN-verified fact-checkers (Snopes, PolitiFact, FactCheck.org, Full Fact, Reuters, AP and friends), Wikipedia, and a research-analyst AI that only cites real authoritative URLs. If nothing solid exists, we say so — we never invent a verdict.",
  },
  {
    q: "How accurate is it?",
    a: "Verdicts are best-effort and generated in seconds. They're a starting point, not a substitute for reading the sources we cite. Every card links out to the underlying evidence so you can decide for yourself.",
  },
  {
    q: "Which videos work?",
    a: "Anything with public captions — YouTube is the most reliable. TikTok, Instagram Reels, X, and Facebook videos also work when the platform doesn't block scraping. Podcasts and long-form talks are our sweet spot.",
  },
  {
    q: "Do you store the videos I check?",
    a: "No. We only cache the verdict (tied to a hash of the URL) so the next person who checks the same video gets an instant result. Cached verdicts auto-delete after 12 h – 30 d depending on the topic.",
  },
  {
    q: "Do I need to install anything?",
    a: "No — TrueStream runs in your browser. If you want share-sheet integration on your phone, add TrueStream to your home screen (it's a PWA) and it will show up in the Android share menu.",
  },
  {
    q: "What about my privacy?",
    a: "We only store the info you give us: your email + Google display name + avatar URL if you sign in. Nothing else. Read the full ",
    aLink: { to: "/privacy", label: "Privacy Policy" },
  },
];

export default function FAQs() {
  const [open, setOpen] = useState(-1);
  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="max-w-[1600px] mx-auto w-full px-6 md:px-12 pb-16 relative z-10"
    >
      <div className="font-mono-plex text-[10px] font-semibold text-zinc-500 mb-3">
        FREQUENTLY ASKED
      </div>
      <h2 className="font-display text-3xl md:text-5xl leading-tight tracking-tight text-zinc-950 mb-8 max-w-2xl">
        Answers, before you ask.
      </h2>
      <div className="max-w-3xl border-t border-zinc-300">
        {FAQS.map((item, i) => {
          const isOpen = open === i;
          return (
            <div key={i} className="border-b border-zinc-300">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? -1 : i)}
                data-testid={`faq-toggle-${i}`}
                aria-expanded={isOpen}
                className="w-full flex items-center justify-between gap-4 py-4 text-left group"
              >
                <span className="font-display text-lg md:text-xl text-zinc-950 leading-snug">
                  {item.q}
                </span>
                <CaretDown
                  weight="bold"
                  className={`w-4 h-4 flex-shrink-0 text-zinc-700 transition-transform ${isOpen ? "rotate-180" : ""}`}
                />
              </button>
              {isOpen && (
                <div className="pb-5 pr-8 text-[14px] text-zinc-700 leading-relaxed">
                  {item.a}
                  {item.aLink && (
                    <a href={item.aLink.to} className="underline hover:text-zinc-950">
                      {item.aLink.label}
                    </a>
                  )}
                  {item.aLink && "."}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
}
